import React from 'react';
import { Button, Modal } from '@syneto/compass-react';
import { advisoryDisplayName, advisoryMatcherSummary } from './firmwareAdvisoryDisplay';

/*
 * Built out of Modal directly rather than on components/ActionModal, which has no way to disable
 * its primary action. Revoking enqueues a job that takes a moment to apply, and without the
 * disable a second click fires a second job against the same advisory.
 *
 * Revoking is one-way in this UI, so the dialog says what stops rather than only asking twice.
 */
const FirmwareAdvisoryRevokeModal = (props) => {
	const { advisory, componentTypes, isSaving, onConfirm, onCancel } = props;

	return (
		<Modal show={Boolean(advisory)} onHide={onCancel}>
			<Modal.Header>
				<Modal.Title>Revoke firmware advisory</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p className="text-value">You are about to revoke the following firmware advisory:</p>

				<dl className="row">
					<dt className="col-4">Component type</dt>
					<dd className="col-8">{advisoryDisplayName(advisory, componentTypes)}</dd>

					<dt className="col-4">Match</dt>
					<dd className="col-8">{advisoryMatcherSummary(advisory)}</dd>

					<dt className="col-4">Affected versions</dt>
					<dd className="col-8">{(advisory?.affectedVersions ?? []).join(', ')}</dd>

					<dt className="col-4">Target version</dt>
					<dd className="col-8">{advisory?.targetVersion}</dd>
				</dl>

				<p className="mb-0">
					Appliances will stop being told to upgrade. The advisory stays in the catalog under the
					Revoked filter, but it cannot be made active again from here.
				</p>
			</Modal.Body>

			<Modal.Footer>
				<Button role="secondary" onClick={onCancel}>Cancel</Button>
				<Button disabled={isSaving} onClick={onConfirm}>Revoke</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default FirmwareAdvisoryRevokeModal;
